(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-magicwire"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initWire(root){
    var svg = root.querySelector('.mw-wire');
    if(!svg) return;
    var path = svg.querySelector('path');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var total = 0;

    function build(){
      var h = root.offsetHeight, w = root.offsetWidth;
      svg.setAttribute('viewBox','0 0 '+w+' '+h);
      svg.style.height = h + 'px';
      var x = Math.min(w*0.16,220), amp = Math.min(w*0.10,130);
      var d = 'M '+x+' 0', steps = Math.max(8, Math.round(h/210));
      for(var i=1;i<=steps;i++){
        var y = h*(i/steps), cx = x + (i%2===0?amp:-amp), cy = h*((i-0.5)/steps);
        d += ' Q '+cx+' '+cy+' '+x+' '+y;
      }
      path.setAttribute('d', d);
      total = path.getTotalLength();
      path.style.strokeDasharray = total;
      path.style.strokeDashoffset = reduce ? 0 : total;
    }

    function onScroll(){
      if(reduce) return;
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight;
      var span = rect.height + vh;
      var progress = (vh - rect.top) / span;      // 0 -> 1 as the section passes through
      progress = Math.max(0, Math.min(1, progress));
      var reveal = Math.min(1, progress*1.2 + 0.05);
      path.style.strokeDashoffset = total*(1-reveal);
    }

    build(); onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', function(){ build(); onScroll(); });
    // re-measure once images/fonts settle
    window.addEventListener('load', function(){ build(); onScroll(); });
  }
  document.querySelectorAll('.mw-story').forEach(initWire);
})();

  } catch(e) { console.error(e); }
})();
})();
